<div class="flex flex-col gap-4 max-w-xl">
  <h2 class="text-xl font-semibold">Send new-eligible-lottery notifications to signup users</h2>
  <p class="text-sm text-muted-color">
    This will queue new-eligible-lottery notifications for all signup users who haven't already
    received one and haven't been seen after the lottery opened.
  </p>
  <div class="flex flex-col gap-2">
    <label class="text-sm font-medium">Lottery</label>
    <p-select
      [options]="openLotteries()"
      [ngModel]="selectedLotteryId()"
      (ngModelChange)="selectedLotteryId.set($event)"
      optionLabel="name"
      optionValue="id"
      placeholder="Select a lottery"/>
  </div>
  <p class="text-sm text-orange-600">Note: this job can take 10+ minutes to finish processing in the background.</p>
  <div class="flex gap-3">
    <admin-submit-button
      [label]="'Send new-eligible-lotteries'"
      [severity]="'primary'"
      [submitFunction]="trigger"
      [disabled]="loading() || !selectedLotteryId()"/>
    <p-button label="Back" severity="secondary" (onClick)="goBack()"></p-button>
  </div>
</div>
